webpackJsonp([2],[
/* 0 */,
/* 1 */
/*!******************************!*\
  !*** ./src/locales/index.js ***!
  \******************************/
/*! exports provided: default, loadLanguage */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadLanguage", function() { return loadLanguage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(/*! vue */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__(/*! vue-i18n */ 34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__en__ = __webpack_require__(/*! ./en */ 5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__en__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
	locale: navigator.language,
	fallbackLocale: 'en',
	messages: { en: __WEBPACK_IMPORTED_MODULE_3__en___default.a }
});

/* harmony default export */ __webpack_exports__["default"] = (i18n);

var supportedLanguages = ['en', 'zh-tw', 'zh-cn'];
var loadedLanguages = ['en'];

function setI18nLanguage(lang) {
	i18n.locale = lang;
	document.getElementsByTagName('html')[0].setAttribute('lang', lang);
	return lang;
}

var loadLanguage = function () {
	var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(lang) {
		var msgs;
		return __WEBPACK_IMPORTED_MODULE_0__opt_build_repo_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						lang = lang.toLowerCase();

						if (supportedLanguages.includes(lang)) {
							_context.next = 3;
							break;
						}

						return _context.abrupt('return', 'en');

					case 3:
						if (!(i18n.locale === lang)) {
							_context.next = 5;
							break;
						}

						return _context.abrupt('return', lang);

					case 5:
						if (!loadedLanguages.includes(lang)) {
							_context.next = 7;
							break;
						}

						return _context.abrupt('return', setI18nLanguage(lang));

					case 7:
						_context.next = 9;
						return __webpack_require__(/*! @/locales */ 35)("./" + lang);

					case 9:
						msgs = _context.sent;

						i18n.setLocaleMessage(lang, msgs);
						loadedLanguages.push(lang);
						return _context.abrupt('return', setI18nLanguage(lang));

					case 13:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadLanguage(_x) {
		return _ref.apply(this, arguments);
	};
}();

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/*!*****************************!*\
  !*** ./src/locales/en.json ***!
  \*****************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

module.exports = {"app":{"title":"Todo List"},"tabs":{"all":"All","undone":"Undone","done":"Done"},"input":{"placeholder":"New Todo","add":"Add"},"todolist":{"notodo":"No todo found."}}

/***/ }),
/* 6 */,
/* 7 */
/*!***********************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/App.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TodoList__ = __webpack_require__(/*! @/components/TodoList */ 21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Tabs__ = __webpack_require__(/*! @/components/Tabs */ 25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AddTodo__ = __webpack_require__(/*! @/components/AddTodo */ 27);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			tabs: [{ key: 'all', text: 'tabs.all' }, { key: 'undone', text: 'tabs.undone' }, { key: 'done', text: 'tabs.done' }]
		};
	},

	components: {
		TodoList: __WEBPACK_IMPORTED_MODULE_1__components_TodoList__["a" /* default */],
		Tabs: __WEBPACK_IMPORTED_MODULE_2__components_Tabs__["a" /* default */],
		AddTodo: __WEBPACK_IMPORTED_MODULE_3__components_AddTodo__["a" /* default */]
	},
	computed: Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['all', 'undone', 'done'])
});

/***/ }),
/* 8 */
/*!****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TodoList.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TodoItem__ = __webpack_require__(/*! @/components/TodoItem */ 22);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		todolist: {
			type: Array,
			required: true
		}
	},
	components: {
		TodoItem: __WEBPACK_IMPORTED_MODULE_1__components_TodoItem__["a" /* default */]
	}
});

/***/ }),
/* 9 */
/*!****************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/TodoItem.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		todo: {
			type: Object,
			required: true
		}
	},
	methods: {
		toggle: function toggle(todo) {
			this.$store.commit('toggle', todo);
		},
		remove: function remove(todo) {
			this.$store.commit('remove', todo);
		}
	}
});

/***/ }),
/* 10 */
/*!************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Tabs.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		tabs: {
			type: Array,
			required: true
		}
	},
	data: function data() {
		return {
			curtab: this.tabs[0].key
		};
	},

	storage: {
		namespace: 'tabs',
		keys: ['curtab']
	}
});

/***/ }),
/* 11 */
/*!***************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AddTodo.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			text: ''
		};
	},

	methods: {
		add: function add(text) {
			if (text.length === 0) return;
			this.$store.commit('add', { text: text });
			this.text = '';
		}
	}
});

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */
/*!****************************!*\
  !*** multi ./src/index.js ***!
  \****************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /opt/build/repo/src/index.js */15);


/***/ }),
/* 15 */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_storage__ = __webpack_require__(/*! vuejs-storage */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(/*! bootstrap/dist/css/bootstrap.css */ 19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_App__ = __webpack_require__(/*! @/components/App */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(/*! @/store */ 30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__locales__ = __webpack_require__(/*! @/locales */ 1);








Object(__WEBPACK_IMPORTED_MODULE_5__locales__["loadLanguage"])(navigator.language).then(function (lang) {
	return console.log('language loaded: %s', lang);
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuejs_storage___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_3__components_App__["a" /* default */]);
	},
	store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
	i18n: __WEBPACK_IMPORTED_MODULE_5__locales__["default"]
});

if ('serviceWorker' in navigator) {
	navigator.serviceWorker.register('/service-worker.js').then(function (reg) {
		reg.onupdatefound = function () {
			var installing = reg.installing;
			installing.onstatechange = function () {
				if (installing.state === 'installed') {
					if (navigator.serviceWorker.controller) {
						console.log('New content is available; please refresh.');
					} else {
						console.log('Content is cached for offline use.');
					}
				}
			};
		};
	}).catch(function (err) {
		return console.error('Service Worker register error:', err);
	});
}

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/*!********************************!*\
  !*** ./src/components/App.vue ***!
  \********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue */ 7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45e7eb09_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-45e7eb09","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue */ 29);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45e7eb09_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 21 */
/*!*************************************!*\
  !*** ./src/components/TodoList.vue ***!
  \*************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_TodoList_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./TodoList.vue */ 8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6316f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoList_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4b6316f0","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./TodoList.vue */ 24);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_TodoList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b6316f0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 22 */
/*!*************************************!*\
  !*** ./src/components/TodoItem.vue ***!
  \*************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_TodoItem_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./TodoItem.vue */ 9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_947332ba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoItem_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-947332ba","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./TodoItem.vue */ 23);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_TodoItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_947332ba_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TodoItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 23 */
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-947332ba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TodoItem.vue ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-group-item list-group-item-action d-flex justify-content-between",class:{ active: _vm.todo.done },on:{"click":function($event){_vm.toggle(_vm.todo)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.todo.text)}}),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.remove(_vm.todo)}}},[_vm._v("X")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 24 */
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b6316f0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TodoList.vue ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-group"},[_vm._l((_vm.todolist),function(todo){return _c('todo-item',{key:todo.id,attrs:{"todo":todo}})}),_vm._v(" "),(_vm.todolist.length===0)?_c('li',{staticClass:"list-group-item text-center",domProps:{"innerHTML":_vm._s(_vm.$t('todolist.notodo'))}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 25 */
/*!*********************************!*\
  !*** ./src/components/Tabs.vue ***!
  \*********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Tabs_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Tabs.vue */ 10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d229b20_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tabs_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-7d229b20","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Tabs.vue */ 26);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Tabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d229b20_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 26 */
/*!**********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d229b20","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tabs.vue ***!
  \**********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',{staticClass:"nav nav-tabs"},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.key,staticClass:"nav-item"},[_c('a',{directives:[{name:"t",rawName:"v-t",value:(tab.text),expression:"tab.text"}],staticClass:"nav-link",class:{ active: tab.key === _vm.curtab },attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.curtab=tab.key}}})])})),_vm._v(" "),_vm._t(_vm.curtab)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 27 */
/*!************************************!*\
  !*** ./src/components/AddTodo.vue ***!
  \************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_AddTodo_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/opt/build/repo/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./AddTodo.vue */ 11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05c45409_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddTodo_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-05c45409","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./AddTodo.vue */ 28);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_opt_build_repo_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_AddTodo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05c45409_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddTodo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 28 */
/*!*************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05c45409","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddTodo.vue ***!
  \*************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('input.placeholder')},domProps:{"value":(_vm.text)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.add(_vm.text)},"input":function($event){if($event.target.composing){ return; }_vm.text=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-append"},[_c('button',{directives:[{name:"t",rawName:"v-t",value:('input.add'),expression:"'input.add'"}],staticClass:"btn btn-outline-secondary",attrs:{"type":"button"},on:{"click":function($event){_vm.add(_vm.text)}}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 29 */
/*!*********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45e7eb09","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue ***!
  \*********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h1',{directives:[{name:"t",rawName:"v-t",value:('app.title'),expression:"'app.title'"}],staticClass:"pt-2"})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('Tabs',{staticClass:"pt-2",attrs:{"tabs":_vm.tabs}},[_c('todo-list',{attrs:{"slot":"all","todolist":_vm.all},slot:"all"}),_vm._v(" "),_c('todo-list',{attrs:{"slot":"undone","todolist":_vm.undone},slot:"undone"}),_vm._v(" "),_c('todo-list',{attrs:{"slot":"done","todolist":_vm.done},slot:"done"})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('add-todo',{staticClass:"pt-2"})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 30 */
/*!**********************!*\
  !*** ./src/store.js ***!
  \**********************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_storage__ = __webpack_require__(/*! vuejs-storage */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuejs_storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuejs_storage__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	state: {
		todolist: []
	},
	mutations: {
		add: function add(state, _ref) {
			var text = _ref.text;

			state.todolist.push({
				text: text,
				id: Date.now().toString() + Math.random(),
				done: false
			});
		},
		remove: function remove(state, _ref2) {
			var id = _ref2.id;

			state.todolist = state.todolist.filter(function (todo) {
				return todo.id !== id;
			});
		},
		toggle: function toggle(state, _ref3) {
			var id = _ref3.id;

			state.todolist.filter(function (todo) {
				return todo.id === id;
			}).forEach(function (todo) {
				return todo.done = !todo.done;
			});
		}
	},
	getters: {
		all: function all(state) {
			return state.todolist;
		},
		done: function done(state) {
			return state.todolist.filter(function (todo) {
				return todo.done;
			});
		},
		undone: function undone(state) {
			return state.todolist.filter(function (todo) {
				return !todo.done;
			});
		}
	},
	plugins: [__WEBPACK_IMPORTED_MODULE_2_vuejs_storage___default()({
		namespace: 'store',
		keys: ['todolist']
	})]
}));

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/*!***********************************!*\
  !*** ./src/locales lazy ^\.\/.*$ ***!
  \***********************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./": [
		1
	],
	"./en": [
		5
	],
	"./en.json": [
		5
	],
	"./index": [
		1
	],
	"./index.js": [
		1
	],
	"./zh-cn": [
		12,
		1
	],
	"./zh-cn.json": [
		12,
		1
	],
	"./zh-tw": [
		13,
		0
	],
	"./zh-tw.json": [
		13,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 35;
module.exports = webpackAsyncContext;

/***/ })
],[14]);


// WEBPACK FOOTER //
// client.7c0f5df9.js